import { appendElement, appendElementIf } from '../xml-helpers';

export function buildTitles(
  parent: Element,
  title: string,
  subtitle?: string | null
): Element {
  const titles = appendElement(parent, 'titles');
  appendElement(titles, 'title', title);
  appendElementIf(titles, 'subtitle', subtitle);
  return titles;
}
